import React, { useCallback } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import tourSteps from './tourSteps';
import { FaAnglesRight, FaAnglesLeft  } from "react-icons/fa6";

const HelpTour = ({ start, setStartTour, onStopTour }) => {


const handleJoyrideCallback = useCallback(
  (data) => {
    const { status, index, type, step } = data;
    console.log(STATUS, status,type,step)

   if (
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status) ||
      type === "tour:end"
    ) {
      setStartTour(false);
      if (onStopTour) onStopTour();
    }

    if (type === "step:before" && step?.target) {
      const element = document.querySelector(step.target);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",   
          inline: "center" 
        });
      }
    }
    if(data.index === tourSteps.length -1){
      const lastButton = document.querySelector(
        "[data-test-id='button-primary']"
      )
      if (lastButton){
        lastButton.innerText = "Finish"
      }
    }
    if(status === "running"){
      const skipButton = document.querySelector(
       "[data-test-id='button-skip']"
      )
      if(skipButton){
        skipButton.innerText = "End Tour"
      }
    }
  },
  [setStartTour, onStopTour]
);

const tootlipStyle ={
 options: {
          zIndex: 10000,
          arrowColor: '#fff',
          backgroundColor: '#fff',
          primaryColor: '#2563eb',
          width: "300px",
        },
  buttonSkip:{
    backgroundColor:" #7b7b7b",
    padding: "10px",
    color: "#fff",
    border: "none",
},
buttonBack:{
    backgroundColor:" #fff",
    border: "1px solid #ddd",
    color: "#7a7a7a",
    fontWeight: "700",
},
buttonNext:{
    backgroundColor:" #fff",
    border: "1px solid #ddd",
    color: "#7a7a7a",
    fontWeight: "700",
},
buttonEnd:{
backgroundColor: "#e03a3a",
color: "#fff",
}
 
}
  return (
    <Joyride
      steps={tourSteps}
      run={start}                 
      continuous
      showSkipButton={true}
      hideCloseButton
      disableCloseOnEsc
      disableOverlayClose
      scrollToFirstStep
      debug
      styles={tootlipStyle}
      callback={handleJoyrideCallback}
      locale={{
       back: <FaAnglesLeft /> ,   
      next: <FaAnglesRight />
  }}
    />
  );
};

export default HelpTour;
